import { ConfigProvider } from 'antd'
import { ThemeProvider } from 'antd-style'
import { PropsWithChildren } from 'react'

import { useLocales } from '../locales'

import { customToken, Global, theme } from './theme'

export const ThemeProviderWrapper = ({ children }: PropsWithChildren) => {
  const { currentLang, t } = useLocales()

  return (
    <ConfigProvider
      locale={currentLang.systemValue}
      form={{ validateMessages: { required: t('form.required') } }}
    >
      <ThemeProvider theme={theme} customToken={customToken}>
        <Global />
        {children}
      </ThemeProvider>
    </ConfigProvider>
  )
}
